import React, { useState, useContext, useEffect, useCallback } from "react";
import CocktailList from "./components/CocktailList";

const AppContext = React.createContext();
const url = "https://www.thecocktaildb.com/api/json/v1/1/search.php?s=";
const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [cocktails, setCocktails] = useState([]);
  const [searchText, setSearchtext] = useState("a");
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(`${url}${searchText}`);
      const data = await response.json();
      if (data.drinks) {
        const newCocktails = data.drinks.map((cocktail) => {
          const { idDrink, strDrink, strDrinkThumb, strAlcoholic, strGlass } =
            cocktail;
          return {
            id: idDrink,
            name: strDrink,
            image: strDrinkThumb,
            info: strAlcoholic,
            glass: strGlass,
          };
        });
        setCocktails(newCocktails);
      } else {
        setCocktails([]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [searchText]);
  useEffect(() => {
    fetchData();
  }, [searchText, fetchData]);
  return (
    <AppContext.Provider
      value={{
        loading,
        setLoading,
        cocktails,
        setCocktails,
        searchText,
        setSearchtext,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export const useGlobalContext = () => {
  return useContext(AppContext);
};
export { AppProvider, AppContext };
